module.exports = "/pages/business/foodslabo/service_icon_2.png";